import { useState } from 'react';
import { resolveTheme, STATUS_COLORS } from '../../designTokens';

export default function FormInput({ theme, label, helperText, error, style, ...rest }) {
  const t = theme || resolveTheme();
  const [focused, setFocused] = useState(false);

  const borderColor = error ? STATUS_COLORS.error : focused ? t.accent : '#d1d5db';
  const boxShadow = focused && !error ? `0 0 0 2px ${t.accent}33` : 'none';

  return (
    <div style={{ marginBottom: '10px', ...style }}>
      {label && (
        <label style={{ display: 'block', fontSize: '0.82em', fontWeight: '600', color: '#374151', marginBottom: '4px' }}>
          {label}
        </label>
      )}
      <input
        onFocus={e => { setFocused(true); rest.onFocus && rest.onFocus(e); }}
        onBlur={e => { setFocused(false); rest.onBlur && rest.onBlur(e); }}
        style={{
          width: '100%',
          padding: '9px 12px',
          borderRadius: '7px',
          border: `1px solid ${borderColor}`,
          fontSize: '0.9em',
          boxSizing: 'border-box',
          outline: 'none',
          boxShadow,
          transition: 'border-color 0.12s, box-shadow 0.12s',
          background: 'white',
        }}
        {...rest}
      />
      {error && <div style={{ marginTop: '4px', fontSize: '0.8em', color: STATUS_COLORS.error }}>{error}</div>}
      {!error && helperText && <div style={{ marginTop: '4px', fontSize: '0.8em', color: t.text_secondary }}>{helperText}</div>}
    </div>
  );
}
